import React, { useEffect } from "react";
import { useStore } from "../../../contexts/StoreProvider";
import {
  IFotaAddSysAdmin,
} from "../../../models/Form/IFotaForm";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";
import { observer } from "mobx-react";
import AddModemFotaForm from "../forms/add-modem-fota-form";
import AddJetFotaForm from "../forms/add-jet-fota-form";
import { Buffer } from 'buffer';

interface IProps {
  id: number;
  isModemView: boolean;
  modalClosed: () => void;
}

const AddEditFotaMzlForm = (props: IProps) => {
  const { fotaMzlStore, groupStore } = useStore();
  const {
    GetFotaMzlReleaseByIdService,
    getFotaMzlRelease,
    fotaMzlReleaseState,
    addUpdateFotaMzlState,
    AddUpdateFotaMzlServiceSysAdminService,
    UpdateFotaMzlServiceSysAdminService,
    resetFotaMzlReleaseState,
    inProgress,
  } = fotaMzlStore;
  const { GetAllGroupService, allAllGroupOptions } = groupStore;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) 
      GetFotaMzlReleaseByIdService(props.isModemView,props.id);
 
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateUserSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateFotaMzlState.success) {
      if (props.id > 0)
        toast.success(formatMessage("updated_success"));
      else
        toast.success(formatMessage("added_success"));
      onModalClosed();
    }
  }, [addUpdateFotaMzlState.success]);

  const handleSubmitSysAdmin = (data: IFotaAddSysAdmin) => {
    let tempWantToUpdateFile = data.WantToUpdateFile === "true" ? true : false;
    const payload: any = {
      Version: data.Version,
      EffectiveDateTimestamp: data.EffectiveDateTimestamp,
      FileName: data.FileName,
      FileInString: data.File,
      FileType:
        typeof data.FileType === "string"
          ? parseInt(data.FileType)
          : data.FileType,
      Description: data.Description?.trim(),
    };
    if (props.id > 0)
      UpdateFotaMzlServiceSysAdminService(props.isModemView, { 
        ...payload,
        WantToUpdateFile: tempWantToUpdateFile,
        FileInString: tempWantToUpdateFile ? data.File : "",
        FileName: tempWantToUpdateFile ? data.FileName : "",
      }, props.id);
    else 
      AddUpdateFotaMzlServiceSysAdminService(props.isModemView, { ...payload });    
  };

  /**
   * This function closes the pop up modal and reset getuserdetails, addUpdate user observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetFotaMzlReleaseState();
    props.modalClosed();
  };

  return (
    <>
      {props.isModemView ? (
        <AddModemFotaForm
          initialValues={getFotaMzlRelease}
          id={props.id}
          submitHandler={handleSubmitSysAdmin}
          onModalClosed={onModalClosed}
          dataLoading={fotaMzlReleaseState.inProgress}
          actionLoading={addUpdateFotaMzlState.inProgress}
        />
      ) : (
        <AddJetFotaForm
          initialValues={getFotaMzlRelease}
          id={props.id}
          submitHandler={handleSubmitSysAdmin}
          onModalClosed={onModalClosed}
          dataLoading={fotaMzlReleaseState.inProgress}
          actionLoading={addUpdateFotaMzlState.inProgress}
        />
      )}
    </>
  );
};

export default observer(AddEditFotaMzlForm);
